import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { RandomColorGenerator } from './components';
import { Homepage } from "./components/main-page"
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/home" element={<Homepage />} />
          <Route path="/" element={<RandomColorGenerator />} />
          <Route path="/:hexCode" element={<RandomColorGenerator />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;